import React from 'react';
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom';

import A from '../../../common/A';
import { URL } from '../../../../constant';

function ProgressLearningTebs() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  
  const menu = [
    { title: t("LC_06_01.msg002"), path: URL.PROGRESS_LEARNING.AI_BAROSEM },
    { title: t("LC_06_01.msg003"), path: URL.PROGRESS_LEARNING.MATHEMATICS }
  ];
  
  const handlePage = (path) => {
    history.push(path);
  };

  return (
    <div className="header bg_white">
      <div className="header_tab2 blue w128">
        <ul className="tablist cls">
          {
            menu.map((item, index) => (
              <li key={index}>
                <A
                  className={
                    location.pathname === item.path ? 'active' : ''
                  }
                  onClick={() => handlePage(item.path)}
                >
                  {item.title}
                </A>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}

export default ProgressLearningTebs;